import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CONFIG_CAT_KEY } from '@app/shared/enum/feature-flag';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-page-title',
    templateUrl: './page-title.component.html',
    styleUrls: ['./page-title.component.scss'],
    standalone: false,
})
export class PageTitleComponent {
    @Input() title: string;
    @Input() description?: string;
    @Input() backLink?: {
        label: string;
        link: string;
    };

    featureDiscovery = {
        key: CONFIG_CAT_KEY.FEATURE_DISCOVERY,
        target: undefined,
    };
    setDefault$: BehaviorSubject<void>;

    constructor(private router: Router) {
        this.featureDiscovery.target = {
            feature: this.router.url,
        };
        this.setDefault$ = new BehaviorSubject<void>(undefined);
    }

    onCloseHelp() {
        this.setDefault$.next();
    }
}
